import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import Response from "../../../model/Response";
import {ArticleStockService} from "../../../service/articleDelivery/ArticleStockService";
import DamagedArticleStockRequest from "../../../model/articleDelivery/DamagedArticleStockRequest";

class CollectDamagedArticleStockStore {

    public entityId: string;
    public articleId: string;
    public damagedAmount: number;
    public amount?: number;
    public comment?: string;
    public isModalOpen: boolean;
    public loading: boolean;
    public success: boolean;
    public commonStore: CommonStore;

    constructor(commonStore: CommonStore, entityId: string, articleId: string, damagedAmount: number) {
        this.entityId = entityId;
        this.articleId = articleId;
        this.damagedAmount = damagedAmount;
        this.isModalOpen = false;
        this.loading = false;
        this.success = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    get enableButton(): boolean {
        return !!this.amount && this.amount > 0 && this.amount <= this.damagedAmount;
    }

    @action
    public openModal() {
        this.amount = this.damagedAmount;
        this.comment = undefined;
        this.success = false;
        this.isModalOpen = true;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public collectAll() {
        this.amount = this.damagedAmount;
    }

    @action
    public async save(): Promise<boolean> {
        this.loading = true;
        const request = new DamagedArticleStockRequest(this.entityId, this.articleId, this.amount!!, this.comment);
        const response: Response<any> = await ArticleStockService.collectDamagedArticleStock(request);
        this.commonStore.processErrors(response);
        this.loading = false;
        this.success = response.success;
        return response.success;
    }

}

export default CollectDamagedArticleStockStore;
